import { ENTITIES, FEATURES, PROVIDERS } from "constants/queryKeys"

import { useQuery } from "react-query"

import type { IShowcase } from "./types"

const showcaseKeys = {
  all: [{ feature: FEATURES.SHOWCASE, provider: PROVIDERS.BACKEND }] as const,
  list: [
    { feature: FEATURES.SHOWCASE, provider: PROVIDERS.BACKEND, entity: ENTITIES.LIST },
  ] as const,
}

// Snapshot of the backend's /showcase response, taken before the backend was
// shut down
const getAllShowcases = async () => {
  const { default: data } = await import("./showcases.snapshot.json")
  return data as IShowcase[]
}

export const useShowcases = () => {
  return useQuery<IShowcase[]>(showcaseKeys.list, getAllShowcases, {
    // these change very rarely
    staleTime: Infinity,
  })
}
